import { createFormState, required, isProbablyEmail } from "redux-freeform";

const formConfig = {
  email: {
    validators: [isProbablyEmail()] // 'required' validator is conditionally added based on `isRequired` prop
  }
};

export const { reducer, mapStateToProps, mapDispatchToProps } = createFormState(
  formConfig
);
